import { cn } from "@app/lib/utils";
import { trans } from "@mongez/localization";
import { useState } from "react";
import { subsidiariesData } from "../data/subsidiariesData";
import { SubsidiaryCard } from "./SubsidiaryCard";
import { SubsidiaryDrawerHeader } from "./SubsidiaryDrawerHeader";

/**
 * Subsidiary drawer component
 * Displays expandable table of subsidiaries with mobile-responsive design
 */
export function SubsidiaryDrawer() {
  const [openSections, setOpenSections] = useState<{ [key: number]: boolean }>(
    {},
  );

  const toggleSection = (index: number) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section className={cn("container my-8 sm:my-10 md:my-12 3xl:my-16")}>
      <div
        className={cn(
          "rounded-2xl bg-white sm:rounded-3xl md:rounded-[45px]",
          "p-4 sm:p-6 md:p-8 lg:p-11",
        )}
      >
        <h3
          className={cn(
            "mb-6 text-2xl sm:mb-8 sm:text-3xl md:text-4xl 3xl:text-5xl",
            "font-semibold text-marine",
          )}
        >
          {trans("aboutUsPage.leadership.subsidiaries.drawerTitle")}
        </h3>

        <SubsidiaryDrawerHeader />

        <div className={cn("space-y-3 sm:space-y-4")}>
          {subsidiariesData.map((company, index) => (
            <SubsidiaryCard
              key={index}
              company={company}
              index={index}
              isOpen={openSections[index] || false}
              onToggle={() => toggleSection(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
